import { useCallback } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';

export enum ExtraSectionIdentifiers {
  Introduction = 'introduction',
  Conclusion = 'conclusion',
}

export const INTRODUCTION_INDEX = -1;

export const LANDSCAPE = 'landscape';
export const PORTRAIT = 'portrait';
export type Orientation = typeof LANDSCAPE | typeof PORTRAIT;

type PrintSettings = {
  slidesPerPage: number;
  orientation: Orientation;
  slides: number[];
};

type ActivityBuilderData = {
  activeSectionId: string;
  printSettings: PrintSettings;
};

export const activityBuilderApollo = makeVar<ActivityBuilderData>({
  activeSectionId: ExtraSectionIdentifiers.Introduction,
  printSettings: {
    slidesPerPage: 1,
    orientation: LANDSCAPE,
    slides: [],
  },
});

export const useActivityBuilderApollo = () => {
  const data = useReactiveVar(activityBuilderApollo);

  const setActiveSection = useCallback(
    (id: string) => {
      activityBuilderApollo({
        ...data,
        activeSectionId: id,
      });
    },
    [data]
  );

  const setPrintSettings = useCallback(
    (printSettings: Partial<PrintSettings>) => {
      activityBuilderApollo({
        ...data,
        printSettings: {
          ...data.printSettings,
          ...printSettings,
        },
      });
    },
    [data]
  );

  return {
    data,
    setActiveSection,
    setPrintSettings,
  };
};
